import React from 'react';

const ChatLengthWarning = ({ 
  chatStats, 
  onCreateNewChat, 
  className = '' 
}) => {
  if (!chatStats || chatStats.status === 'normal') {
    return null;
  }

  const getMessage = () => {
    switch (chatStats.status) {
      case 'approaching':
        return 'This chat is getting long. For best results,';
      case 'warning':
        return 'This chat is very long. For best results,';
      case 'critical':
      case 'blocked':
        return 'This chat is too long. For best results,';
      default:
        return 'This chat is getting long. For best results,';
    }
  };

  return (
    <div className={`w-full max-w-[800px] mx-auto px-2 pb-3 max-[1200px]:max-w-[760px] max-[900px]:max-w-[700px] [@media(max-height:800px)]:max-w-[740px] [@media(max-height:700px)]:max-w-[680px] ${className}`}>
      <div className="text-xs text-gray-500 dark:text-[#999999] text-right">
        {getMessage()}{' '}
        <button
          onClick={onCreateNewChat}
          className="underline hover:text-gray-700 dark:hover:text-gray-300 transition-colors"
        >
          create a new chat
        </button>.
        {chatStats.isDebugMode && (
          <span className="ml-2 font-mono opacity-60">
            (debug)
          </span>
        )}
      </div>
    </div>
  );
};

export default ChatLengthWarning;